import {
  getCurrentSlot,
  advanceSlot,
  getProgram,
  getCurrentSlotIdx,
} from '../state/program-store.js';
import { renderSlot } from './renderer.js';
import { preloadNext } from './preloader.js';
import { logInfo, logWarn } from '../state/log-store.js';
import { slotDurationMs } from './slot-timing.js';

let timer = null;
let rootElRef = null;
/** Bumped on stop/start so stale async renderSlot cannot append a second image. */
let rotationGeneration = 0;

export function showBlackScreen(rootEl) {
  stopRotation();
  if (rootEl) rootEl.innerHTML = '';
}

export function startRotation(rootEl) {
  rootElRef = rootEl;
  stopRotation();
  next(rootEl);
}

/** Resume current slot without resetting index (admin / after sync). */
export function resumeRotation() {
  if (!rootElRef) return;
  stopRotation();
  next(rootElRef);
}

export function stopRotation() {
  rotationGeneration += 1;
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
}

function scheduleAdvance(rootEl, slot) {
  const generation = rotationGeneration;
  let done = false;
  const advance = () => {
    if (done || generation !== rotationGeneration) return;
    done = true;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    advanceSlot();
    next(rootEl);
  };

  void renderSlot(rootEl, slot, {
    onEnded: advance,
    isStale: () => generation !== rotationGeneration,
  }).catch((err) => {
    if (generation !== rotationGeneration) return;
    logWarn('Slot render failed', { error: err.message, slotId: slot.id });
    setTimeout(advance, 3000);
  });

  void preloadNext();

  const durationMs = slotDurationMs(slot.durationSec);
  timer = setTimeout(() => {
    if (generation !== rotationGeneration) return;
    advance();
  }, durationMs);
}

function next(rootEl) {
  const slot = getCurrentSlot();
  if (!slot) {
    showBlackScreen(rootEl);
    timer = setTimeout(() => next(rootEl), 5000);
    return;
  }
  logInfo('Slot rendering', {
    kind: slot.kind,
    id: slot.id,
    idx: getCurrentSlotIdx(),
    durationSec: slot.durationSec,
  });

  scheduleAdvance(rootEl, slot);
}
